import { Thread } from "duck/ui/chat/types";

const THREAD_ID_STORAGE_KEY = "chat_ai_thread_id";

/**
 * Retrieves the stored thread ID from session storage.
 */
export const getStoredThreadId = (): string | null =>
  sessionStorage.getItem(THREAD_ID_STORAGE_KEY);

/**
 * Sets or removes the thread ID in session storage.
 */
export const setStoredThreadId = (threadId: string | null): void => {
  if (threadId) {
    sessionStorage.setItem(THREAD_ID_STORAGE_KEY, threadId);
  } else {
    sessionStorage.removeItem(THREAD_ID_STORAGE_KEY);
  }
};

export const getThreadFromThreads = (threads: Thread[], threadId: string) =>
  threads.find(({ id }) => id === threadId);

export const threadNeedsTitleUpdate = (thread: Thread | null) =>
  thread?.id && thread.title === null;
